import { ScrollText } from 'lucide-react'
import { Link } from '@tanstack/react-router'

import type { HomeWidgetDefinition } from '@/lib/home-widgets'
import { AUDIT_PERMISSIONS } from '@/lib/permissions'

import { RecentActivityWidget } from './features/recent-activity/recent-activity-widget'

export const auditHomeWidgets = [{
  id: 'audit.recent-activity', name: 'Recent activity', description: 'Recent changes recorded for the selected entity.',
  icon: ScrollText, order: 50,
  defaultSize: { columns: 2, rows: 4 }, minimumSize: { columns: 1, rows: 3 },
  permission: AUDIT_PERMISSIONS.read,
  viewAll: ({ entityId, className }) => <Link to="/$entityId/audit-log" params={{ entityId }} className={className}>View all activity</Link>,
  component: RecentActivityWidget,
}] satisfies readonly HomeWidgetDefinition[]
